import React from "react";
import cx from "classnames";
import { AssistantMessageProps } from "@copilotkit/react-ui";
import { Markdown } from "./Markdown";
import LoadingDots from "./LoadingIcon";

export const AssistantMessage = (props: AssistantMessageProps): JSX.Element => {
	const { message, isLoading } = props;
	return (
		<div className={cx("msg-bubble", "assistant")}>
			{message && <Markdown content={message || ""} />}
			{isLoading && <LoadingDots />}
		</div>
	);
};
